import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { debounceTime, filter } from 'rxjs/operators';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';
import { Subscription } from 'rxjs';
import { businessConstants } from '../../../../constants/business.constants';
import { ContactService } from '@tamalelibs/services/contact.service';

@Component({
    selector: 'tam-contact-job-function',
    templateUrl: './contact-job-function.component.html',
    styleUrls: ['./contact-job-function.component.scss'],
    standalone: false
})
export class ContactJobFunctionComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() childConfig: any;
    @Input() valueChangeSubject: ReplaySubject<ContactTemplateControlValue>;
    @ViewChild('entitylist', { static: false }) entitylist;
    config: any;
    readOnly = false; // flag to disable auto complete
    selectedDictionary: any = {}; // selected items, using dictionary for quickly removing duplicates
    inputValue = ''; // input box text value
    isHasSearchValue = false;
    suggestionItems: Array<any> = []; // suggestion items based on search, sub set of dataItems
    dataItems: Array<any> = []; // data items based on search, sub set of dataItems
    selectedItems: Array<any> = []; // selected items, sub set of dataItems
    hintContent = '';
    searchValue: string;
    tempAddItemList: Array<string> = [];
    private _filterHandler$: Subject<string> = new Subject();
    private _jobFunctions: Array<string> = [];
    private _el: HTMLElement;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _element: ElementRef,
        private renderer: Renderer2,
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
        private _contactService: ContactService,
    ) {
        this._el = this._element.nativeElement;
    }

    ngOnInit() {
        this.config = this.childConfig.config;
        this._initExistJobFunctions();
        if (this.config.action === ContactTemplateType.EditContact) {
            this.selectedItems = this.config.editValue;
        }
        this._filterHandler$.pipe(
            debounceTime(250),
        ).subscribe(filterStr => this.searching(filterStr));
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && this.selectedItems.length === 0 && this.config.isRequired) {
                    this.hintContent = businessConstants.tip;
                }
            }));
        this.changeValueSet(false);
    }

    ngAfterViewInit() {
        // Updated selector for new Kendo UI version
        const inputElement = this._el.querySelector('.k-multiselect .k-input-inner');
        if (inputElement) {
            this.renderer.setAttribute(inputElement, 'maxLength', '256');
        }
    }

    ngOnDestroy() {
        this.tempAddItemList = [];
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    handleFilter(value) {
        this._filterHandler$.next(value);
    }

    onOpen(event: any): void {
        if (this.dataItems.length === 0) {
            event.preventDefault();
        } else {
            this.entitylist.toggle(true);
        }
    }

    medOnFocus(event: any) {
        this.suggestionItems = this.dataItems;
    }

    valueChange(tappedItem) {
        if (tappedItem) {
            this.hintContent = '';
            this.entitylist.toggle(false);
            this._contactTemplateService.changeValueStatus = true;
            this.selectedDictionary = [];
            // tslint:disable-next-line: forin
            this.tempAddItemList.forEach(res => {
                if (tappedItem.findIndex(item => item === res) === -1) {
                    // this.suggestionItems.reduce
                    for (let i = 0; i < this.suggestionItems.length; i++) {
                        if (this.suggestionItems[i] === res) {
                            this.suggestionItems.splice(i, 1);
                        }
                    }
                }
            });
            this.changeValueSet(true);
        } else {
            this.entitylist.toggle(false);
        }
    }

    clearValue() {
        this.inputValue = '';
        this.selectedItems = null;
        this.entitylist.clearFilter();
        this.entitylist.toggle(false);
        this.changeValueSet(true);
    }

    createJobFunction() {
        if (this.searchValue && (this.searchValue !== null && this.searchValue !== '')) {
            this.hintContent = '';
            this.suggestionItems = this.dataItems;
            this.suggestionItems.push(this.searchValue);
            this.selectedItems.push(this.searchValue);
            this.tempAddItemList.push(this.searchValue);
            this.entitylist.clearFilter();
            this.entitylist.toggle(false);
            this.changeValueSet(true);
        }
    }

    private _initExistJobFunctions() {
        this._destroySubscriptions.push(
            this._contactService.getJobFunction().subscribe(res => {
                if (res && res.length > 0) {
                    res.forEach(element => {
                        this._jobFunctions.push(element.name);
                    });
                    this.dataItems = this.suggestionItems = this._jobFunctions.sort();
                }
            }));
    }

    private searching(value) {
        this.searchValue = '';
        this.suggestionItems = this.dataItems.filter((content) => content.toLowerCase().indexOf(value.toLowerCase()) !== -1).sort();
        this.isHasSearchValue = this.dataItems.findIndex((content) => content.toLowerCase() === value.toLowerCase()) !== -1;
        if (!this.isHasSearchValue && value) {
            this.searchValue = value;
        }
    }

    /**
     * set  jobFunction value
     *
     * @private
     * @param {boolean} isFromUser
     * @memberof ContactJobFunctionComponent
     */
    private changeValueSet(isFromUser: boolean) {
        const value = new ContactTemplateControlValue(this.selectedItems, this.selectedItems, this.config);
        if (this.valueChangeSubject) {
            this.valueChangeSubject.next(value);
        }
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
